export const API_CALCULATOR_FORM_SERVICE_NAME = 'calcForm';
export const API_SUBMISSION_FORM_SERVICE_NAME = 'submissionForm';

export const API_SET_VALUE_METHOD_NAME = 'setFieldValue';

export const API_STATIC_ENDPOINTS_SCHEMA = {
  [API_CALCULATOR_FORM_SERVICE_NAME]: true
};

export const MAX_CALCULATOR_FORMAT_FRACTION_DIGITS = 5;
